import React, { useState } from "react";
import Layout from "../../../HOC/layout/Layout";
import AddProduct from "../../PageComponent/Product/AddProduct";
import ViewProduct from "../../PageComponent/Product/ViewProduct";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import SecondaryHeader from "../../UI/SecondaryHeader/SecondaryHeader";
import SecondaryHeaderSmallDev from "../../UI/SecondaryHeader/SecondaryHeaderSmallDev";
function Product() {
  const [showData, setShowData] = useState("Add");
  const SearchText = () => {
    console.log(4);
  };
  return (
    <ContextApi>
      <Layout>
        <div>
          <SecondaryHeader
            setShowData={setShowData}
            showData={showData}
            addBtn="AddProduct"
            viewBtn="ViewProduct"
            SearchText={SearchText}
          />
          {showData === "Add" ? <AddProduct /> : <ViewProduct />}
        </div>
      </Layout>
    </ContextApi>
  );
}

export default Product;
